import styled from "styled-components";

export const StyledWrapperLoader = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`;
